/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import  '../node_modules/bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import SlickSlider from './components/slick';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';


import './components/block-cart';
import lazysizes from 'lazysizes'

/*menu fixe*/
import Headroom from "headroom.js";

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

function autoPlayYouTubeModal(){
  var trigger = $("body").find('[data-toggle="modal"]');
  trigger.click(function() {
    var theModal = $(this).data( "target" ),
    videoSRC = $(this).attr( "data-theVideo" );
	  if (videoSRC.includes('?')){
		  var videoSRCauto = videoSRC+"&autoplay=1" ;
	  }else{
		  var videoSRCauto = videoSRC+"?autoplay=1" ;
	  }
    $(theModal+' .modal-body').html('<iframe width="100%" height="600" src="" allowfullscreen="allowfullscreen"></iframe>');
    $(theModal+' iframe').attr('src', videoSRCauto);
    $(theModal+' button.close').click(function () {
        $(theModal+' iframe').attr('src', videoSRC);
    }); 
    
     $(theModal).modal('show');
    
    $('body #modal').click(function () {
         $(theModal+' iframe').attr('src', '');
         $(theModal+' iframe').attr('src', videoSRC);
    }); 
  });
}

/*********************************************************/
/* Affichage popup video youtube sur le click */
/*********************************************************/

if($(".block-video  .banner-item-content>a").length>0){
		var linkVideo=$(".block-video .banner-item-content>a").attr("href");
		$(".block-video  .banner-item-content .custom-html").wrap('<a href="'+linkVideo+'"></a>');
	}

var linkYoutube = $('.block-video .banner-item-content a');

linkYoutube.each(function(){
	var youtubeAttr = $(this).attr('href');
	$(this).attr('href','#').attr('data-toggle','modal').attr('data-target','#modal').attr('data-thevideo', youtubeAttr);
});


$(document).ready(() => {
  const test = 270479;
  const form = new Form();
  let slickSlider = new SlickSlider();
  let topMenuEl = $('#_desktop_top_menu #top-menu');
  let topMenu = new TopMenu(topMenuEl);

  form.init();
  slickSlider.init();
  /*topMenu.init();*/

  //display input file content in custom file input BS
  $('.custom-file-input').on('change',function(){
      let fileName = $(this).val().split('\\').pop();
      $(this).next('.custom-file-label').addClass("selected").html(fileName);
  })
  
  
   //menu fixe avec la librairie headroom.js
  if (prestashop.responsive.mobile) {
  	const header = document.querySelector(".header-top");
  	const headroom = new Headroom(header);
		headroom.init();
	}
	else{
		const header = document.querySelector(".l-header");
		const headroom = new Headroom(header);
		headroom.init();
	}
  
    //display searchbar
  $('.btn-expand-collapse').click(function(e) {
					$('.search-widget').toggleClass('collapsed');
	});

	//hover/focus sur header
	$( "body #header .header__right" ).hover(
		function() {
			$("#search_widget").css("top", $("#header").height()-7);  //pr savoir � quelle hauteur va s'ouvrir la recherche
			if (prestashop.responsive.mobile) {
				$("#search_widget").css("top", $("#header .header-top").height()+16);
			}
		}, function() {

		}
	);


	/****transformer les tableaux en tableau responsive pr les pages CMS: appliqu� apr�s un timeout pour que les pages CMS des fiches produits se chargent avant****/	
		setTimeout(function() {
       $(".page-content--cms table").each(function(e) {
				$(this).wrap( "<div class='table-responsive'></div>" );
			});
    }, 500);
	
	
	/****couper/ouvrir paragraphe presentation home****/	
	
	var text_mask = $("#custom-text .mask-text");
	var rte = text_mask.find(".rte");
	if (text_mask.length > 0 ){
		var rte_height = rte.height();
//		if (prestashop.responsive.mobile) {
			rte.addClass("close_rte");	
//		}
		$("#custom-text .toggle").click(function(e) {
			var status = rte.hasClass("open");
			if(!status){
				rte.removeClass("close_rte");
				rte.addClass("open");		
				rte.css("max-height",rte_height);		
			}
			else{
				rte.css("max-height","inherit");			
				rte.removeClass("open");		
				rte.addClass("close_rte");
				
//			}
//			rte.toggleClass("open",!status);
//			if(status){
				$('html, body').animate({
					scrollTop: $("#custom-text").offset().top-100}, 1200);
				}
		});
	}
	
/****couper/ouvrir paragraphe presentation category****/	
	
	var text_category = $("#_desktop_category-description");

//	var rte = text_category.find(".rte")
	if (text_category.length > 0) {
			var $toggle = $(".block-category .toggle");
			var $scroller = $(document.scrollingElement || document.documentElement);
			var COLLAPSED_HEIGHT = 104; // doit matcher le max-height SCSS

			function collapse() {
				text_category.css('max-height', COLLAPSED_HEIGHT);
				text_category.removeClass('open');
			}

			$toggle.on('click', function () {
				var isOpen = text_category.hasClass('open');

				if (isOpen) {
					var $wrap = $(".category_header_txt_desc");
					var target = $wrap.offset().top - 100;
					var needsScroll = $scroller.scrollTop() > target;

					if (needsScroll) {
						// un seul élément animé => un seul callback, plus de double déclenchement
						$scroller.stop(true).animate({ scrollTop: target }, 300).promise().done(collapse);
					} else {
						// bloc déjà visible : pas de scroll parasite
						collapse();
					}
				} else {
					text_category.css('max-height', text_category[0].scrollHeight);
					text_category.addClass('open');
				}
			});
	}
	
	
	/****affichage image dans page SEO de advanced search****/	
	
	var blockCategorySeo = $(".block-category-seo");
	if (blockCategorySeo.length > 0 ){
		if($("#_desktop_category-description img").length > 0){
				$( ".category-cover" ).append( $("#_desktop_category-description img") );
		}
	}


	/****vignettes images home et custombanners1 cliquable****/	
	/*if($(".displayHome  .banner-item-content>a").length>0){
				$(".displayHome  .banner-item").click(function(e){
					if ($(this).find(".banner-item-content>a").length) {
						if($(this).find(".banner-item-content>a").attr('target')=='_blank'){
							window.open($(this).find(".banner-item-content>a").attr("href"));
						} 
						else document.location.href = $(this).find(".banner-item-content>a").attr("href");
						e.preventDefault();
					}
				});
	}*/
	if($(".displayCustomBanners1 .banner-item-content>a").length>0){
				$(".displayCustomBanners1  .banner-item").click(function(e){
					if ($(this).find(".banner-item-content>a").length) {
						if($(this).find(".banner-item-content>a").attr('target')=='_blank'){
							window.open($(this).find(".banner-item-content>a").attr("href"));
						} 
						else document.location.href = $(this).find(".banner-item-content>a").attr("href");
						e.preventDefault();
					}
				});
	}
	
if (!prestashop.responsive.mobile) {
	autoPlayYouTubeModal();
}

//supression de la balise address sur les page CMS : balise qui sert pour avoir lien en savoir plus sur onglet fiche produit
	$(".page-content--cms address").remove();

});
document.addEventListener('lazyloaded', function(e){
    $(e.target).parent().addClass('rc--lazyload');
});

	/****detection de l'ouverture/fermeture collapse des facets (filtres) en mobile ****/	

if($(".PM_ASBlockOutput").length>0){

	$('body').on('show.bs.collapse', '.collapse--facet', function() {
		$(this).parents(".facet__block").addClass("facet__block_show");
	});
	
	$('body').on('hide.bs.collapse', '.collapse--facet', function() {
		$(this).parents(".facet__block").removeClass("facet__block_show");
	});
}
	


/* back to top*/
var btn = $('#link-main-container');

$(window).scroll(function() {
  if ($(window).scrollTop() > 350) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});
